import moment from 'moment'

export const dateToString = (date, format = "MMM Do, YYYY") => date && moment.utc(date).format(format);
